
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import { default as dayjs } from 'dayjs';
import { default as duration } from 'dayjs/plugin/duration';

dayjs.extend(duration);

export default defineComponent({
  emits: ['finished'],
  props: {
    minutes: {
      type: Number,
      required: true
    },
    asTag: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const displayedTime = ref();
    const end = dayjs().add(props.minutes as number, 'minute');

    const resetDuration = () => {
      if (end.diff() > 0) {
        displayedTime.value = dayjs.duration(end.diff()).format('HH:mm:ss');
      } else {
        emit('finished');
        clearInterval(timerInterval);
      }
    }

    const timerInterval = setInterval(() => {
      resetDuration();
    }, 33);

    onMounted(() => {
      resetDuration();
    });

    onBeforeUnmount(() => {
      clearInterval(timerInterval);
    });

    return {
      displayedTime,
      asTag: props.asTag
    };
  }
})
